import { render, staticRenderFns } from "./ProjectPeriodicSlackNotificationSettings.vue?vue&type=template&id=39f6b3ec&scoped=true&"
import script from "./ProjectPeriodicSlackNotificationSettings.vue?vue&type=script&lang=js&"
export * from "./ProjectPeriodicSlackNotificationSettings.vue?vue&type=script&lang=js&"
import style0 from "./ProjectPeriodicSlackNotificationSettings.vue?vue&type=style&index=0&id=39f6b3ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39f6b3ec",
  null
  
)

export default component.exports